import { IUser } from "services/types";
import { IUserList } from "components/feed/GifList";

export const filterUsersList = (prevUsers: IUserList, newUsers: IUser[]) => {
  const users = { ...prevUsers };

  newUsers.forEach((user: IUser) => {
    users[user.username] = user;
  });

  return users;
};
